/**
 * Calculator component.
 * Wrap the three calculator modes into a single view and let
 * the user switch between them.
 *
 */

import React from 'react';

// import CalcVolume from './calc-volume';
import CalcStandardDrinks from './calc-standard-drinks';
import EnterStandardDrinks from './enter-standard-drinks';


class Calculator extends React.Component {
  constructor() {
    super();
    this.state = {
      ChildView: EnterStandardDrinks,
    };
  }

  showCalculator = () => {
    this.setState({
      ChildView: CalcStandardDrinks,
    });
  }

  showStandos = () => {
    this.setState({
      ChildView: EnterStandardDrinks,
    });
  }

  render() {
    const { ChildView } = this.state;

    return (
      <div className="view calculator">
        <header>
          <h1>Add a drink</h1>
        </header>

        <ChildView
          showCalculator={this.showCalculator}
          showStandos={this.showStandos}
        />

      </div>
    );
  }
}

export default Calculator;



// WEBPACK FOOTER //
// ./src/components/calculator.js